{
  "page.title": "Review and sign",
  "page.loading": "Loading your document…",
  "page.poweredBy": "Secured by Workspace369 E-Signature",
  "page.senderFrom": "{sender} from {workspace}",
  "page.sentToSign": "{from} sent you a document to sign",
  "page.sentToApprove": "{from} sent you a document to approve",
  "page.sentToView": "{from} shared a document with you",
  "header.asksSign": "{workspace} asks you to sign",
  "header.asksApprove": "{workspace} asks you to approve",
  "header.asksReview": "{workspace} asks you to review",
  "header.from": "from {workspace}",
  "header.pages.one": "{count} page",
  "header.pages.other": "{count} pages",
  "banner.verified": "Verified as {email}. Each step is time-stamped in the audit trail.",
  "banner.signingAs": "Signing as {name}. Each step is time-stamped in the audit trail.",
  "banner.inPerson": "Signing in person as {name}. Each step is time-stamped in the audit trail.",

  "state.invalid.title": "This link isn't valid",
  "state.invalid.body": "It may have been replaced by a newer link, or it has expired. Check your email for the most recent message from the sender.",
  "state.unavailable.title": "Signing is temporarily unavailable",
  "state.unavailable.body": "Please try again later.",
  "state.not_your_turn.title": "It isn't your turn yet",
  "state.not_your_turn.body": "We'll email you when the document is ready for you.",
  "state.finished_waiting.title": "You're done",
  "state.finished_waiting.signedTitle": "You've signed",
  "state.finished_waiting.approvedTitle": "You've approved",
  "state.finished_waiting.body": "We're waiting for the others to finish. We'll email you the completed document as soon as they do.",
  "state.sealing.title": "Everyone has finished",
  "state.sealing.body": "Completed, your sealed copy is on its way.",
  "state.completed.title": "This document is complete",
  "state.completed.body": "Your sealed copy was emailed to you.",
  "state.declined.title": "This request was declined",
  "state.declined.body": "Signing has ended for everyone. You don't need to do anything.",
  "state.voided.title": "This request was voided",
  "state.voided.body": "The sender cancelled this request. You don't need to do anything.",
  "state.expired.title": "This request has expired",
  "state.expired.body": "Ask the sender to send it again.",
  "state.finish_later.title": "You can finish later",
  "state.retry": "Try again",
  "done.you": "{name} · you",
  "done.signedNow": "Signed just now",
  "done.signed": "Signed",
  "done.next": "Signs next",
  "done.waiting": "Waiting",
  "done.nextBody": "{name} signs next. We'll email you the completed document as soon as everyone has signed.",
  "done.orderLabel": "Signing order",
  "done.copyUnavailable": "This download is no longer available here. We'll email you the completed document.",

  "verify.title": "Verify your email",
  "verify.enterCode": "Enter the code we emailed you",
  "verify.body": "To keep this document private, we'll send a 6-digit code to {email}.",
  "verify.yourEmail": "your email address",
  "verify.sentTo": "We sent a 6-digit code to {email}. It expires in 10 minutes.",
  "verify.send": "Send code",
  "verify.sending": "Sending…",
  "verify.codeLabel": "Verification code",
  "verify.digitLabel": "Digit {position} of 6",
  "verify.submit": "Verify",
  "verify.verifying": "Verifying…",
  "verify.resend": "Send a new code",
  "verify.resendIn": "Send a new code in {seconds}s",
  "verify.turnstile": "Complete the check below to request another code.",
  "verify.turnstileFailed": "The security check could not load. Disable content blockers for this page, then try again.",
  "verify.turnstileRetry": "Try again",
  "verify.readyTitle": "Review the document",
  "verify.readyBody": "Continue to review and sign.",
  "verify.continue": "Continue",

  "consent.title": "Before you continue",
  "consent.version": "Version {version}",
  "consent.noticeLabel": "Electronic records and signatures notice",
  "consent.agreeLabel": "I have read this notice and agree to use electronic records and signatures.",
  "consent.agree": "I agree",
  "consent.decline": "Decline",

  "document.nextField": "Next field",
  "document.remaining.one": "{count} required field left",
  "document.remaining.other": "{count} required fields left",
  "document.allDone": "All required fields are done",
  "document.progress": "{done} of {total} fields done",
  "document.progressShort": "{done} of {total}",
  "document.progressLabel": "Required fields completed",
  "document.finishSign": "Sign and finish",
  "document.approve": "Approve",
  "document.reject": "Reject",
  "document.acknowledge": "I have reviewed this document",
  "document.more": "More options",
  "document.moreShort": "More",
  "document.downloadOriginal": "Download original",
  "document.declineAction": "Decline to sign",
  "document.finishLater": "Finish later",
  "document.finishLaterBody": "You can come back with the link in your email. For your security, you'll verify again.",
  "document.pageLabel": "Page {page} of {count}",
  "document.renderFailed": "We couldn't display this document. Try downloading the original.",

  "field.signature": "Signature for {name}",
  "field.initials": "Initials for {name}",
  "field.text": "{label} for {name}",
  "field.textUnlabeled": "Text for {name}",
  "field.checkbox": "Checkbox for {name}",
  "field.dateSigned": "Date signed, filled when you finish",
  "field.name": "Your name, filled when you finish",
  "field.required": "required",
  "field.optional": "optional",
  "field.clickToSign": "Click to sign",
  "field.tapToSign": "Tap to sign",
  "field.clickToInitial": "Initial",
  "field.filledOnFinish": "Filled when you finish",
  "field.completedBy": "Completed by another signer",
  "guide.sign": "Sign here",
  "guide.initial": "Initial here",
  "guide.fill": "Fill in",
  "guide.check": "Check",
  "bar.signature": "Signature",
  "bar.initials": "Initials",
  "bar.text": "Text",
  "bar.checkbox": "Checkbox",
  "bar.position": "Field {index} of {total} · page {page}",
  "bar.positionOptional": "Optional · field {index} of {total} · page {page}",
  "bar.sign": "Sign",
  "bar.initial": "Initial",
  "bar.fill": "Fill in",
  "bar.check": "Check",
  "bar.next": "Next",
  "bar.skip": "Skip",

  "adopt.title": "Your signature",
  "adopt.initialsTitle": "Your initials",
  "adopt.draw": "Draw",
  "adopt.type": "Type",
  "adopt.drawLabel": "Draw your signature in this box",
  "adopt.clear": "Clear",
  "adopt.typedLabel": "Full name",
  "adopt.typedInitialsLabel": "Initials",
  "adopt.preview": "Preview",
  "adopt.fontLabel": "Choose a style",
  "adopt.font.dancing_script": "Style 1",
  "adopt.font.great_vibes": "Style 2",
  "adopt.font.caveat": "Style 3",
  "adopt.legal": "By selecting Adopt, I agree that this mark is my electronic signature and has the same effect as my handwritten signature.",
  "adopt.confirm": "Adopt",
  "adopt.cancel": "Cancel",

  "finish.intentSign": "By selecting Sign and finish, I intend to sign this document electronically.",
  "finish.intentApprove": "By selecting Approve, I approve this document electronically.",
  "finish.intentAcknowledge": "By confirming, I acknowledge that I have reviewed this document.",
  "finish.submitting": "Finishing…",

  "decline.title": "Decline to sign",
  "decline.rejectTitle": "Reject this document",
  "decline.body": "Declining ends this request for everyone and tells the sender. Please say why.",
  "decline.reasonLabel": "Reason",
  "decline.reasonHint": "At least 5 characters.",
  "decline.confirm": "Decline",
  "decline.cancel": "Keep reviewing",

  "error.generic": "Something went wrong. Please try again.",
  "error.network": "We couldn't reach the signing service. Check your connection and try again.",
  "error.VALIDATION_FAILED": "Something in the request wasn't valid. Reload the page and try again.",
  "error.LINK_INVALID": "This link isn't valid anymore. Check your email for the most recent message.",
  "error.NOT_FOUND": "This link isn't valid anymore. Check your email for the most recent message.",
  "error.SIGNING_UNAVAILABLE": "Signing is temporarily unavailable. Please try again later.",
  "error.TURNSTILE_REQUIRED": "Complete the security check to request another code.",
  "error.RATE_LIMITED": "Too many attempts. Please wait a few minutes and try again.",
  "error.INVALID_CODE.one": "That code isn't right. You have {count} try left.",
  "error.INVALID_CODE.other": "That code isn't right. You have {count} tries left.",
  "error.CODE_EXPIRED": "That code has expired. Request a new one.",
  "error.TOO_MANY_ATTEMPTS": "Too many wrong codes. Request a new one.",
  "error.VERIFICATION_REQUIRED": "Verify your email to continue.",
  "error.CONSENT_REQUIRED": "Please review and accept the notice to continue.",
  "error.SESSION_EXPIRED": "For your security, your session ended. Verify your email again to continue.",
  "error.NOT_YOUR_TURN": "It isn't your turn to act on this document.",
  "error.CONTRACT_CLOSED": "This document can no longer be signed.",
  "error.DOCUMENT_CHANGED": "This document changed after it was sent, so it can't be signed. Contact the sender.",
  "error.DISCLOSURE_OUTDATED": "The notice was updated. Please review it again.",
  "error.REQUIRED_MISSING": "Complete the required fields before you finish.",
  "error.FIELD_INVALID": "One of the fields isn't valid. Check your entries and try again.",
  "error.SIGNATURE_INVALID": "Your signature couldn't be used. Please adopt it again.",
  "error.REASON_REQUIRED": "Please enter a reason of at least 5 characters.",
  "error.SEALING_IN_PROGRESS": "Everyone has finished. Your sealed copy is on its way.",
  "error.ACCESS_ENDED": "The download period for this document has ended.",
  "error.ACTION_NOT_ALLOWED": "Your role can't do this.",
  "error.DOCUMENT_REQUIRED": "This document isn't available.",
  "error.INTERNAL": "Something went wrong on our side. Please try again.",
  "completed.download": "Download signed copy",
  "completed.downloading": "Preparing your download…",
  "completed.verifyToDownload": "Verify your email to download the signed copy. The link works for 30 days after signing.",
  "verifyPage.title": "Verify a signed document",
  "verifyPage.intro": "Check whether a PDF was sealed by Workspace369 E-Signature and has not changed since.",
  "verifyPage.privacy": "Your file never leaves your device. Only its fingerprint (SHA-256) is checked.",
  "verifyPage.drop": "Drop a PDF here",
  "verifyPage.choose": "Choose a PDF",
  "verifyPage.checking": "Checking…",
  "verifyPage.notPdf": "Choose a PDF file.",
  "verifyPage.tooLarge": "This file is too large to check here.",
  "verifyPage.match.contract": "This document was sealed by Workspace369 E-Signature and has not changed.",
  "verifyPage.match.certificate": "This certificate of completion was issued by Workspace369 E-Signature and has not changed.",
  "verifyPage.field.title": "Title",
  "verifyPage.field.workspace": "Sent by",
  "verifyPage.field.completed": "Completed",
  "verifyPage.field.signers": "Signed by",
  "verifyPage.field.seal": "Seal",
  "verifyPage.adobeNote": "You can also check the embedded signature in Adobe Acrobat Reader: open the PDF and look at the Signature Panel.",
  "verifyPage.noMatch": "This file was not issued by Workspace369 E-Signature, or it has been changed since it was sealed.",
  "verifyPage.tombstoned": "This document was issued by Workspace369 E-Signature. Its record was deleted by its owner on request.",
  "verifyPage.again": "Check another file"
}
